import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { LabelService } from '../../services/label.service';
import { ErrorPanelService } from '../../services/error-panel.service';
import { TokenService } from '../../services/token.service';
import { DoctorService } from '../../services/doctor.service';
import { MatIconModule } from '@angular/material/icon';
import { GoogleCalendarService } from '../calendar-page/google-calendar.service';
import {
  animate,
  style,
  transition,
  trigger,
  query,
  stagger,
} from '@angular/animations';
import { DoctorPersonalArea } from '../../models/doctor-model';

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [SharedModule, MatIconModule],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '0.6s ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('cardAnimation', [
      transition(':enter', [
        query(
          'section',
          [
            style({ opacity: 0, transform: 'translateY(30px)' }),
            stagger(100, [
              animate(
                '0.6s cubic-bezier(0.35, 0, 0.25, 1)',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class HomepageComponent implements OnInit {
  isMobile = false;

  profilePicture: string = '';

  color: string = '#F6FAFF';

  doctor: DoctorPersonalArea = {
    first_name: '',
    last_name: '',
    signin_mail: '',
  };

  constructor(
    private router: Router,
    public labelService: LabelService,
    private cdRef: ChangeDetectorRef,
    public errorPanelService: ErrorPanelService,
    private tokenService: TokenService,
    private doctorService: DoctorService,
    private googleCalendarService: GoogleCalendarService
  ) {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  ngOnInit(): void {
    if (this.isMobile) {
      document.body.style.height = window.innerHeight + 'px';
    }
    this.color = '#4aa4c0';
    this.profilePicture = sessionStorage.getItem('profilePicture') || '';
    this.cdRef.detectChanges();

    this.tokenService.getGoogleAccessToken().subscribe((token) => {
      if (token) {
        this.googleCalendarService
          .loadPsicogeniusCalendar(token)
          .catch((error) => {
            console.error('Error loading Psicogenius calendar:', error);
            this.errorPanelService.showErrorSnackBar(
              'Errore durante il caricamento del calendario Psicogenius'
            );
          });
      }
    });
    this.getDoctor();
  }

  getDoctor() {
    this.doctorService.getDoctorPersonalArea().subscribe({
      next: (doctor: DoctorPersonalArea) => {
        this.doctor = doctor;
      },
      error: (error) => {
        console.error('Error loading doctor:', error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante il caricamento dei dati del professionista'
        );
      },
    });
  }

  logout() {
    this.tokenService.clearAllTokens();
    this.router.navigate(['/']);
  }

  navigateToPage(page: string) {
    this.router.navigate([page]);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
    if (this.isMobile) {
      document.body.style.height = window.innerHeight + 'px';
    }
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  getCardAnimationDelay(index: number): string {
    return `animation-delay: ${index * 0.1}s;`;
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    const cards = document.querySelectorAll('.clickable');

    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      (card as HTMLElement).style.setProperty('--mouse-x', `${x}px`);
      (card as HTMLElement).style.setProperty('--mouse-y', `${y}px`);
    });
  }
}
